var _this = this,
  _jsxFileName = "/builds/EgNbCExi/0/ramsey-solutions/ramsey-plus/survey-ui/src/components/SubmitButton/SubmitButton.js";
/* eslint-disable no-extra-parens */
import React from "react";
import Button from "react-gazelle/lib/components/Button";
var SubmitButton = function SubmitButton(_ref) {
  var currentPage = _ref.currentPage,
    totalPages = _ref.totalPages,
    disabled = _ref.disabled;
  var SUBMIT_BUTTON_DEFAULT = "Next";
  var SUBMIT_BUTTON_LAST_PAGE = "Submit";

  /**
   * Makes a best guess of whether or not this is a 'terminal' question until supported by the API
   * @param  {number} current Current page number
   * @param  {number} total Total pages number
   * @returns {string} The expected string
   */
  var submitButtonText = function submitButtonText(current, total) {
    var overallProgress = total - current;
    var isFinished = function isFinished(value) {
      return value === 1;
    };
    return isFinished(overallProgress) ? SUBMIT_BUTTON_LAST_PAGE : SUBMIT_BUTTON_DEFAULT;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: disabled,
    type: "submit",
    "data-testid": "SubmitButton",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 7
    }
  }, submitButtonText(currentPage, totalPages)));
};
export { SubmitButton as default };